import React from 'react';
import InnerHeader from "./InnerHeader"
import MainMenu from './MainMenu';
import Paper from '@mui/material/Paper';

import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent, {timelineOppositeContentClasses} from '@mui/lab/TimelineOppositeContent';

import CalculateIcon from '@mui/icons-material/Calculate';
import SchoolIcon from '@mui/icons-material/School';
  

function Resume(){
    return(
        <div>
            <InnerHeader/>
            
            <Paper elevation={2} style={{padding:"10px", marginTop:"10px", fontFamily:"Times New Roman", fontSize: "16pt"}}>
            <h1 style={{textAlign:"center"}}>Huo Chen</h1>

            <u>Experiences</u>
            <Timeline
                sx={{
                    [`& .${timelineOppositeContentClasses.root}`]: {
                    flex: 0.1,
                    },
                }}
            >
                <TimelineItem>
                    <TimelineOppositeContent color="textSecondary">2013-Present</TimelineOppositeContent>
                    <TimelineSeparator>
                    <TimelineDot color="primary">
                        <CalculateIcon />
                    </TimelineDot>
                    <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                        <b>High School Teacher</b><br />
                        <i>New York City Department of Education (Bronx High School of Science)</i><br />
                        <span>I teach AP Computer Science and AP Statistics. I also taught Coding for All (Python), Geometry, Pre-Calculus, and Math Team in the past.</span>
                        <ul>
                            <li>Emeritus, Math for America (2022 - 2023)</li>
                            <li>Master Teacher, Math for America (2018 - 2022)</li>
                            <li>Early Career Fellow, Math for America (2014 - 2018)</li>
                        </ul>
                    </TimelineContent>
                </TimelineItem>

                <TimelineItem>
                    <TimelineOppositeContent color="textSecondary">2013</TimelineOppositeContent>
                    <TimelineSeparator>
                    <TimelineDot color="primary">
                        <CalculateIcon />
                    </TimelineDot>
                    </TimelineSeparator>
                    <TimelineContent>
                        <b>Elementary School English Teacher</b><br />
                        <i>Teach and Learn in Korea Program, Ministry of Education, Republic of Korea</i><br />
                        <span>A half a year teaching fellowship in Jeonju, South Korea.</span>
                    </TimelineContent>
                </TimelineItem>
            </Timeline>

            <u>Education</u>
            <Timeline
                sx={{
                    [`& .${timelineOppositeContentClasses.root}`]: {
                    flex: 0.1,
                    },
                }}
            >
                <TimelineItem>
                    <TimelineOppositeContent color="textSecondary">2012</TimelineOppositeContent>
                    <TimelineSeparator>
                    <TimelineDot 
                      sx={{ 
                        backgroundColor: '#009688'
                      }}
                    >
                        <SchoolIcon />
                    </TimelineDot>
                    <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                        <b>M.A. in Mathematics Education</b><br />
                        <i>Teachers College, Columbia University, New York, NY</i><br />
                        <ul>
                            <li>(Winter) Study abroad program in Russia</li>
                        </ul>
                    </TimelineContent>
                </TimelineItem>

                <TimelineItem>
                    <TimelineOppositeContent color="textSecondary">2013</TimelineOppositeContent>
                    <TimelineSeparator>
                    <TimelineDot 
                      sx={{ 
                        backgroundColor: '#009688'
                      }}
                    >
                        <SchoolIcon />
                    </TimelineDot>
                    </TimelineSeparator>
                    <TimelineContent>
                        <b>B.S. (Summa Cum Laude) in Mathematics; Applied Mathematics and Statistics</b><br />
                        <i>Stony Brook University, SUNY, Stony Brook, NY</i><br />
                        <ul>
                            <li>Summa Cum Laude</li>
                            <li>Dean's list for 4 years</li>
                            <li>Double Majors in <b>Mathematics</b>; <b>Applied Mathematics and Statistics</b></li>
                            <li>Double Minors in <b>Electrical Engineering</b>; <b>Korean Studies</b></li>
                            <li>(Summer) Study Abroad Program in Seoul, South Korea</li>
                        </ul>
                    </TimelineContent>
                </TimelineItem>
            </Timeline>

            <u>Skills</u>
            <ul>
                <li>Language: English, Chinese(Mandarin), Chinese(Cantonese)</li>
                <li>Software: Git, Github</li>
                <li>Programming: Java, Python, Javascript, PHP, SQL, VB, C++, Bootstrap Web framework, React.JS, Dart, Flutter</li>
                <li>Statistics: Python (NymPy, pandas, matplotlib, seaborn, statsmodels, scikit-learn, etc.), SQL, SPSS, Tableau</li>
            </ul>

            <u>Certification</u>
            <ul>
                <li>New York State Public School Teacher Certificate - Mathematics 7-12 (Professional)</li>
                <li>Society of Actuaries (SOA) - Probability Exam (SOA Exam P)</li>
                <li><a href="https://www.coursera.org/account/accomplishments/specialization/A8D7FP74R893" target="_blank">Google Cybersecurity Certificate</a></li>
                <li><a href="https://coursera.org/share/7068ab873dee3d9e526b91b73223c334" target="_blank">Google Advanced Data Analytics Professional Certificate</a></li>
            </ul>
           </Paper> 
           <MainMenu shareLink="https://huoatwork.github.io/#/resume" />
        </div>
    )
}

export default Resume